<template>
  <div class="py-5">
    <div class="container">
      <iframe
        src="https://natuurpoortvanloon.recras.nl/onlineboeking"
        frameborder="0"
        width="100%"
        height="522px"
        ref="recras"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ec-business-recras',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
